var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSticker3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_5769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.262 104.667C85.1793 104.667 107 82.8458 107 55.9285C107 29.0112 85.1793 7.19043 58.262 7.19043C31.3447 7.19043 9.52393 29.0112 9.52393 55.9285C9.52393 82.8458 31.3447 104.667 58.262 104.667Z",
    fill: "#4A25A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8983 44.2832L41.621 26.0811H51.8392L47.8893 41.2643H50.8087L36.7266 63.1069L40.333 44.2832H36.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1014 44.2832L68.8241 26.0811H79.0423L75.0924 41.2643H78.0119L63.9297 63.1069L67.5361 44.2832H64.1014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_5769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker3);
export default __webpack_public_path__ + "static/media/sticker3.3df8220047dfc40d3171ee7b7e1aa8d2.svg";
export { ForwardRef as ReactComponent };